import { createAsyncThunk } from "@reduxjs/toolkit";
import { ethers } from "ethers";
import { selectWalletInfo } from "..";
import OutputI from "../../../interfaces/Output";
import ClaimAuctionGold from "../../../services/ethers/claim-auction-gold";
import ReducerSliceNames from "../../constants/reducerSliceNames";
import { useAppSelector } from "../../hooks";

export const claimAuctionGoldName = 'ClaimAuctionGold';

/**
 * @returns The new a amount of gold after claiming.
 */
const claimAuctionGoldAsyncAction = createAsyncThunk(
  `${ReducerSliceNames.WALLET_INFO}/${claimAuctionGoldName}`,
  async (
    {provider}:
    {provider: ethers.providers.Web3Provider}): Promise<OutputI<{
        fetchCurrentGoldResult: number,       
        fetchHighest: number
    }>> => {
    try {   
      const claimGoldResult = await ClaimAuctionGold(provider);
      if(claimGoldResult.err) throw new Error(claimGoldResult.msg);
      if(claimGoldResult.output === undefined) throw new Error("New gold amount is undefined");
      const output = claimGoldResult.output;
      return { err: false, output };
    } catch (error) {
      const msg = `claimAuctionGoldAsyncAction.ts::claimAuctionGoldAsyncAction():: Failed to claim gold! | \n${error}`;
      return { err: true, msg };
    }
  }
);
export default claimAuctionGoldAsyncAction